var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.89 65.87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:var(--konflux-icon-color, #1A1A1A);stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-2{fill:var(--konflux-primary-color, #FF9D76);stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38,65.87c16.51,0,29.9-13.39,29.9-29.9S54.51,6.08,38,6.08s-29.9,13.39-29.9,29.9,13.39,29.9,29.9,29.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.95,33.39l8.97,8.97,20.93-20.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.9,61.79c16.51,0,29.9-13.39,29.9-29.9S48.41,2,31.9,2,2,15.39,2,31.9s13.39,29.9,29.9,29.9Z"
  }))));
};
export default SvgSuccess;